import { Link } from "react-router-dom";
import { hasRole } from "../../../components/Utils";
import { OvalLoader } from "../../../components/common/Loader";
import { BRAND, GRADIENTS } from "../../../constant/theme";
import userIcon from "../../../assets/images/icons/user_white.png";
import tysIcon from "../../../assets/images/icons/tys_white.png";
import oneToOneIcon from "../../../assets/images/icons/one_to_one_white.png";
import referralsIcon from "../../../assets/images/icons/referrals_white.png";
import visitorsIcon from "../../../assets/images/icons/visitors_white.png";
import chiefGuestsIcon from "../../../assets/images/icons/chief_guests_white.png";
import powerDatesIcon from "../../../assets/images/icons/power_dates_white.png";
import inductionsIcon from "../../../assets/images/icons/inductions_white.png";

// Card configuration with icons, colors, and data mapping
const cardConfig = [
  {
    key: "countries",
    label: "Countries",
    icon: "bx-globe",
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "countryCount",
    link: "/countries",
    permission: "countries-list",
    roles: [1],
  },
  {
    key: "states",
    label: "States",
    icon: "bx-map",
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "stateCount",
    link: "/states",
    permission: "states-list",
    roles: [1, 6],
  },
  {
    key: "regions",
    label: "Regions",
    icon: "bx-map-pin",
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "regionCount",
    link: "/regions",
    permission: "regions-list",
    roles: [1, 6, 7],
  },
  {
    key: "chapters",
    label: "Chapters",
    icon: "bx-buildings",
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "chapterCount",
    link: "/chapters",
    permission: "chapters-list",
    roles: [1, 6, 7, 2],
  },
  {
    key: "members",
    label: "Members",
    imageIcon: userIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "usersCount",
    link: "/users",
    permission: "members-list",
    roles: null,
  },
  // { key: "countryAdmins", label: "Country Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "countryAdminUsersCount", link: "/country-admin-users", permission: "country-admins-list", roles: [1] },
  // { key: "stateAdmins", label: "State Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "stateAdminUsersCount", link: "/state-admin-users", permission: "state-admins-list", roles: [1, 6] },
  // { key: "regionAdmins", label: "Region Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "regionAdminUsersCount", link: "/region-admin-users", permission: "region-admins-list", roles: [1, 6, 7] },
  // { key: "chapterAdmins", label: "Chapter Admins", icon: "bx-shield-quarter", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "chapterAdminUsersCount", link: "/chapter-admin-users", permission: "chapter-admins-list", roles: [1, 6, 7, 2] },
  {
    key: "fbms",
    label: "R2R",
    imageIcon: oneToOneIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "one2oneCount",
    link: "/one-to-one",
    permission: "dashboard-121s-data-view",
    roles: null,
  },
  {
    key: "rfls",
    label: "RFLs",
    imageIcon: referralsIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "referralsCount",
    link: "/referrals",
    permission: "dashboard-rfls-data-view",
    roles: null,
  },
  {
    key: "tyns",
    label: "TYNs",
    imageIcon: tysIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "tynsCount",
    link: "/tyfcbs",
    permission: "dashboard-tyns-data-view",
    roles: null,
  },
  {
    key: "generalVisitors",
    label: "General Visitors",
    imageIcon: visitorsIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "generalVisitorsCount",
    link: "/visitors/general",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "chiefGuest",
    label: "Chief Guest",
    imageIcon: chiefGuestsIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "chiefGuestCount",
    link: "/visitors/chief-guest",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "inductions",
    label: "Inductions",
    imageIcon: inductionsIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "inductionsCount",
    link: "/visitors/inductions",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  {
    key: "powerDate",
    label: "Power Date",
    imageIcon: powerDatesIcon,
    color: BRAND.white,
    gradientBg: GRADIENTS.analyticsCard,
    dataKey: "powerDateCount",
    link: "/visitors/power-date",
    permission: "dashboard-visitors-data-view",
    roles: null,
  },
  // { key: "events", label: "Events", icon: "bx-calendar-event", color: "#1A4331", gradientBg: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)", dataKey: "eventsCount", link: "/events", permission: "events-list", roles: null },
];

const AnalyticsCards = ({ data, ovalLoading, hasPermission }) => {
  // Filter visible cards based on role and permission
  const visibleCards = cardConfig.filter((card) => {
    if (card.roles && !hasRole(card.roles)) return false;
    if (!hasPermission(card.permission)) return false;
    return true;
  });

  return (
    <div className="analytics-cards-grid">
      {visibleCards.map((card) => (
        <Link to={card.link} key={card.key} className="analytics-grid-card">
          <div className="analytics-grid-card-content">
            <div className="analytics-grid-card-data">
              <span className="analytics-grid-card-value">
                {ovalLoading ? (
                  <OvalLoader color={card.color} />
                ) : (
                  (data[card.dataKey] || 0).toLocaleString("en-IN")
                )}
              </span>
              <span className="analytics-grid-card-label">{card.label}</span>
            </div>
            <div
              className="analytics-grid-card-icon"
              style={{ background: card.gradientBg, color: card.color }}
            >
              {card.imageIcon ? (
                <img
                  src={card.imageIcon}
                  alt={card.label}
                  className="analytics-grid-card-icon-image"
                />
              ) : (
                <i className={`bx ${card.icon}`}></i>
              )}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default AnalyticsCards;
